import * as v from "valibot";
import { FEEDBACK_TYPES, REPORT_REASONS } from "../feedback";
import { articleKey } from "./shared.dto";

export const MAX_REPORT_EXPLANATION_LENGTH = 250;

export const feedbackTypeDto = v.picklist(FEEDBACK_TYPES);

export const getArticleFeedbackRequest = articleKey;
export const getArticleFeedbackResponse = {
  feedbackType: v.optional(feedbackTypeDto),
};

export const putArticleFeedbackRequest = { ...articleKey, feedbackType: feedbackTypeDto };

export const removeArticleFeedbackRequest = articleKey;

export const reportArticleRequest = {
  ...articleKey,
  reason: v.picklist(REPORT_REASONS),
  explanation: v.optional(v.pipe(v.string(), v.maxLength(MAX_REPORT_EXPLANATION_LENGTH))),
};
